import React, { useState } from 'react';
import { PlayIcon } from 'lucide-react';
interface LazyYouTubeEmbedProps {
  videoId: string;
  title: string;
}
export function LazyYouTubeEmbed({
  videoId,
  title
}: LazyYouTubeEmbedProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [thumbnailUrl, setThumbnailUrl] = useState(`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`);
  if (!isLoaded) {
    return <button type="button" onClick={() => setIsLoaded(true)} className="relative w-full h-full group cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[#ff6b35]" aria-label={`Video abspielen: ${title}`} data-id="element-162" data-mp="13tmegsjaxc7m">
        <img src={thumbnailUrl} alt={title} width={1280} height={720} decoding="async" className="w-full h-full object-cover" onError={() => setThumbnailUrl(`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`)} data-id="element-163" data-mp="p4geh2cn3hyo" />
        <div className="absolute inset-0 bg-black/40 group-hover:bg-black/25 transition-colors duration-200 flex items-center justify-center" data-id="element-164" data-mp="21lvtzru1jt6">
          <div className="w-20 h-20 bg-[#ff6b35] rounded-full flex items-center justify-center shadow-2xl transition-transform duration-150 ease-out group-hover:scale-105 group-active:scale-95" data-id="element-165" data-mp="6zx4i76e5o9t">
            <PlayIcon className="w-9 h-9 text-white ml-1" fill="white" data-id="element-166" data-mp="3teq6jksxuyit" />
          </div>
        </div>
      </button>;
  }
  return <iframe src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`} title={title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-167" data-mp="3fimh04t0feco" />;
}